module.exports = __webpack_public_path__ + "img/arrow_down_square_hover.d4c1dbe9.svg";